import styled from 'styled-components';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'PostStub' })
    .attrs((props) => ({
        ...props,
        px: 4,
        py: 6,
        overflow: 'hidden',
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: props.borderRadius || '0 0 24px 24px',
        background: props.background || 'var(--background-primary)',
    }))``;

export const Title = styled(Typography)
    .withConfig({ displayName: 'PostStubTitle' })
    .attrs((props) => ({
        ...props,
        as: 'h3',
        variant: 'title3',
        weight: 'bold',
        mb: 1,
        textAlign: 'center',
    }))``;
